import { useNewCode, useVariant } from '@calendly/feature-check-react'

import {
  AI_CHAT_DISCOVERY_EXPERIMENT_KEY,
  AI_CHAT_DISCOVERY_VARIANT,
  getAiChatDiscoveryEffectiveVariant,
} from './constants'

/**
 * Right rail `ai_chat` pane: phase 1 only for `button_test_d` (effective variant) with CAF chat enabled.
 */
export const useAiChatRightRailGuard = () => {
  const isCafChatEnabled = useNewCode('caf_frontend_chat_feature')?.enabled
  const variant = useVariant(AI_CHAT_DISCOVERY_EXPERIMENT_KEY, true)

  if (!isCafChatEnabled) return false
  const effectiveVariant = getAiChatDiscoveryEffectiveVariant(variant)
  return effectiveVariant === AI_CHAT_DISCOVERY_VARIANT.BUTTON_ONLY
}
